import BOND from './BOND.json';
import DEFAULT from './DEFAULT.json';
import FI_ETF from './FI_ETF.json';
import FIETF1 from './FIETF1.json';
import INTERNATIONAL_STOCK from './INTERNATIONAL_STOCK.json';
import MONEY_MARKET from './MONEY_MARKET.json';
import PREFX from './PREFX.json';
import RPSIX from './RPSIX.json';
import ST_ETF from './ST_ETF.json';
import TEEFX from './TEEFX.json';
import TMSRX from './TMSRX.json';
import TMSSX from './TMSSX.json';
import TRANSPARENT_ETF from './TRANSPARENT_ETF.json';
import EQUITY_INCOME_ETF from './EQUITY_INCOME_ETF.json';

const layouts = {
    BOND,
    DEFAULT,
    FI_ETF,
    FIETF1,
    INTERNATIONAL_STOCK,
    MONEY_MARKET,
    PREFX,
    RPSIX,
    ST_ETF,
    TEEFX,
    TMSRX,
    TMSSX,
    TRANSPARENT_ETF,
    EQUITY_INCOME_ETF
};

export default layouts;
